import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Home as HomeIcon, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import TourCard, { TourCardSkeleton } from "@/components/TourCard";
import WeatherWidget from "@/components/WeatherWidget";

export default function DestinationDetail() {
  const { slug } = useParams();
  const [dest, setDest] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0); setDest(null); setNotFound(false);
    api.get(`/destinations/${slug}`).then((r) => setDest(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="flex min-h-[50vh] items-center justify-center"><h1 className="font-display text-3xl font-bold text-navy">Destination not found</h1></div>;
  if (!dest) return <div className="mx-auto max-w-7xl px-4 py-10"><div className="h-72 w-full skeleton rounded-3xl" /></div>;

  return (
    <>
      <SEO title={`${dest.name} Tour Packages | Happy Holidays Wale`} description={dest.description} image={dest.image} />
      <div className="relative h-[45vh] min-h-[320px] overflow-hidden">
        <img src={dest.image} alt={dest.name} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/90 to-navy/20" />
        <div className="relative mx-auto flex h-full max-w-7xl flex-col justify-end px-4 pb-10 md:px-8">
          <nav className="mb-3 flex items-center gap-2 text-sm text-white/70">
            <Link to="/" className="flex items-center gap-1 hover:text-white"><HomeIcon className="h-4 w-4" /> Home</Link>
            <ChevronRight className="h-4 w-4" /><Link to="/destinations" className="hover:text-white">Destinations</Link>
            <ChevronRight className="h-4 w-4" /><span className="text-white">{dest.name}</span>
          </nav>
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">{dest.name}</h1>
          <p className="mt-2 max-w-xl text-white/80">{dest.description}</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid gap-8 lg:grid-cols-[1fr_340px]">
          <div>
            <h2 className="mb-6 font-display text-2xl font-bold text-navy">Packages in {dest.name}</h2>
            {dest.tours?.length ? (
              <div className="grid gap-6 sm:grid-cols-2">{dest.tours.map((t) => <TourCard key={t.id} tour={t} />)}</div>
            ) : (
              <div className="rounded-3xl border border-dashed border-gray-200 py-16 text-center text-gray-500" data-testid="destination-no-tours">
                No packages yet for {dest.name}. <Link to="/enquiry" className="font-semibold text-brandorange">Enquire for a custom trip →</Link>
              </div>
            )}
          </div>
          <div><WeatherWidget city={dest.name} /></div>
        </div>
      </div>
    </>
  );
}
